import { useProductFilters } from "@nosto/search-js/preact/hooks";
import Pill from "@/elements/Pill/Pill";

export default function SelectedFilters() {
  const { filters } = useProductFilters();
  const formatPriceWithCurrency = (filterValue: string) => {
    return filterValue.replace(/(\d+(\.\d+)?)/g, "$$$1");
  };

  return (
    filters.length > 0 && (
      <ul>
        {filters.map((filter) => (
          <li key={`${filter?.name}: ${filter?.value}`}>
            <Pill
              onClick={(e) => {
                e.preventDefault();
                filter?.remove();
              }}
            >
              <span>{filter?.name}: </span>
              {filter?.filter?.range ? (
                <span>{formatPriceWithCurrency(filter?.value)}</span>
              ) : (
                <span>{filter?.value}</span>
              )}
            </Pill>
          </li>
        ))}
      </ul>
    )
  );
}
